export default "__VITE_ASSET__B6khdNin__"